import { Input } from "@/components/ui/Input";
import { Search } from "lucide-react";
import { useEffect, useRef } from "react";

export function ModelSearchBar({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    searchInputRef.current?.focus();
  }, []);

  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-sands-400" />
      <Input
        ref={searchInputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search models..."
        title="Drag a model into the scene to place it"
        accent="healing"
        surface="muted"
        borderWeight="thin"
        inputSize="sm"
        className="pl-9"
      />
    </div>
  );
}
